import React, { useEffect, useState } from "react";
import "./StudyMaterial.css";
import Sidebar from "../Components/Sidebar";

const StudyMaterial = () => {
  const [treeData, setTreeData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedNode, setSelectedNode] = useState(null);
  const API_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const token = localStorage.getItem("jwtToken");
    if (!API_URL) {
      setLoading(false);
      return;
    }
    fetch(`${API_URL}/study-material`, {
      headers: {
        Authorization: token ? `Bearer ${token}` : undefined,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (!data.error) {
          setTreeData(data.data);
        }
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [API_URL]);

  const toggleExpand = (chapter) => {
    chapter.expanded = !chapter.expanded;
    setTreeData([...treeData]);
  };

  const renderTree = (nodes) => {
    return nodes.map((node) => (
      <div key={node.chapter_id} className="study-tree-node">
        <div
          className={`study-tree-title ${
            selectedNode?.chapter_id === node.chapter_id ? "study-active" : ""
          }`}
          onClick={() => setSelectedNode(node)}
        >
          {node.subchapters.length > 0 && (
            <span
              className="study-toggle-btn"
              onClick={(e) => {
                e.stopPropagation();
                toggleExpand(node);
              }}
            >
              {node.expanded ? "▼" : "▶"}
            </span>
          )}
          {node.title}
        </div>

        {node.expanded && node.subchapters.length > 0 && (
          <div className="study-sub-tree">{renderTree(node.subchapters)}</div>
        )}
      </div>
    ));
  };

  return (
    <div className="overview">
      <Sidebar />
      <div className="study-container">
        <div className="study-sidebar">
          <h2 className="study-sidebar-title">Study Material</h2>

          {loading ? (
            <p className="study-loading">Loading...</p>
          ) : treeData.length === 0 ? (
            <p className="study-no-data">No study material found</p>
          ) : (
            <div className="study-tree-container">{renderTree(treeData)}</div>
          )}
        </div>

        <div className="study-content-area">
          {selectedNode ? (
            <div>
              <h2>{selectedNode.title}</h2>

              <p
                className="study-content"
                dangerouslySetInnerHTML={{ __html: selectedNode.content }}
              ></p>

              {selectedNode.content_bangla && (
                <div className="study-content-bangla">
                  <h3 className="study-bangla-title">
                    {selectedNode.title_bangla}
                  </h3>

                  <p
                    className="study-content study-bangla-content"
                    dangerouslySetInnerHTML={{
                      __html: selectedNode.content_bangla,
                    }}
                  ></p>
                </div>
              )}
            </div>
          ) : (
            <div className="study-placeholder">
              <h1>Life in the UK: A Guide for New Residents</h1>
              <p>
                <br></br>
              </p>
              <h2>3rd Edition, updated for 2025</h2>
              <p>
                "Life in the United Kingdom: A guide for new residents, 3rd
                Edition" (
                <a
                  href="https://britizen.uk/study-guide#pdf-version"
                  target="_blank"
                  rel="noreferrer"
                  style={{ color: "rgb(70, 64, 165)" }}
                >
                  PDF version
                </a>
                ) contains all the information that you need to pass the
                official life in the UK test. All of the questions will be based
                on this publication.
              </p>
              <p>
                The latest (3rd) edition of the book was introduced in 2013 and
                will remain valid for 2025 and consequent years. It requires an
                understanding of the English language at English for Speakers of
                Other Languages (ESOL) Entry Level 3 to read and understand the
                material. We strongly recommend reading the publication at least
                once and completing all available practice tests to pass the
                test with ease.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default StudyMaterial;
